import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';


const CustomTooltip = (props) => {
  return(
      <div className="tooltip">
        <sup><a className="atooltip">{props.text}</a></sup>
        <div className="tooltiptext">
        {props.caption}
        {props.children}
        </div>
      </div>
  )
};
export default CustomTooltip;
